import { render } from "./UPIPayment.vue?vue&type=template&id=76dcc0e4&scoped=true"
import script from "./UPIPayment.vue?vue&type=script&lang=js"
export * from "./UPIPayment.vue?vue&type=script&lang=js"

import "./UPIPayment.vue?vue&type=style&index=0&id=76dcc0e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76dcc0e4"]])

export default __exports__